import React from 'react';
import PropTypes from 'prop-types';


const StepsHeading = ({ children }) => (
  <div className="steps-section__heading">
    {children}
  </div>
);

StepsHeading.propTypes = {
  children: PropTypes.node,
};

StepsHeading.defaultProps = {
  children: undefined,
};

export default StepsHeading;
